import faviconBlackIco from "./assets/icons/favicon-black.ico";
import faviconBlackSvg from "./assets/icons/favicon-black.svg";
import faviconWhiteIco from "./assets/icons/favicon-white.ico";
import faviconWhiteSvg from "./assets/icons/favicon-white.svg";

(function () {
  function updateFavicon() {
    // Detect system dark mode preference
    const isDarkMode = window.matchMedia(
      "(prefers-color-scheme: dark)"
    ).matches;

    // Select appropriate favicon files using imported assets
    // Vite automatically resolves these to the correct paths in both dev and production
    const icoHref = isDarkMode ? faviconWhiteIco : faviconBlackIco;
    const svgHref = isDarkMode ? faviconWhiteSvg : faviconBlackSvg;

    // Update ICO favicon
    const icoLink = document.querySelector("link[rel='icon'][sizes='any']");
    if (icoLink) {
      icoLink.setAttribute("href", icoHref);
    }

    // Update SVG favicon
    const svgLink = document.querySelector(
      "link[rel='icon'][type='image/svg+xml']"
    );
    if (svgLink) {
      svgLink.setAttribute("href", svgHref);
    }
  }

  // Update on initial load
  updateFavicon();

  // Listen for system theme changes
  const darkModeMediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
  darkModeMediaQuery.addEventListener("change", updateFavicon);
})();
